import { NavigationConfiguration } from '../Main/components/Layout';
import { RootState } from '../../../store/reducers';

export const selectIsTokenVerified = (state: RootState): boolean => state.auth.isTokenVerified;

export const selectUserNavigation = (state: RootState): NavigationConfiguration => state.auth.navigation;

export const selectUserToken = (state: RootState): string => state.auth.token;
